// extracted by mini-css-extract-plugin
export default {"wrapper":"QSegQ4be","iconAddon":"gI9jthyP","icon":"ueFXmO0e","input":"MDqO5pF3"};